import { CheckIcon, CopyIcon } from '@radix-ui/react-icons';
import { Button } from '../../Button';
import DocumentInput from '../../DocumentInput';
import { Input } from '../../Input';
import { useSendForSignatureModalController } from './useSendForSignatureModalController';

export default function SendForSignatureModal() {
  const {
    t,
    register,
    errors,
    signerDocument,
    createdRequest,
    copied,
    isSubmitting,
    handleSignerDocumentChange,
    handleSubmit,
    handleCopyLink,
    handleCloseModal,
  } = useSendForSignatureModalController();

  if (createdRequest) {
    return (
      <div className="mt-4 flex flex-col gap-4">
        <div className="flex flex-col gap-1">
          <strong className="text-text-primary text-sm md:text-base">
            {t('contract.signature.modal.success.title')}
          </strong>
          <p className="text-text-secondary text-xs md:text-sm">
            {t('contract.signature.modal.success.hint')}
          </p>
        </div>

        <div className="border-border-input bg-surface-input flex items-center gap-2 rounded-lg border p-2">
          <span className="text-text-primary flex-1 truncate text-xs md:text-sm">
            {createdRequest.publicUrl}
          </span>
          <Button
            color="outline"
            size="icon"
            aria-label={t('contract.signature.modal.success.copy')}
            onClick={handleCopyLink}
          >
            {copied ? (
              <CheckIcon className="size-4" />
            ) : (
              <CopyIcon className="size-4" />
            )}
          </Button>
        </div>

        <p className="rounded-lg bg-amber-50 p-3 text-xs text-amber-800 md:text-sm dark:bg-amber-900/30 dark:text-amber-200">
          {t('contract.signature.modal.success.validity')}
        </p>

        <Button
          color="primary"
          labelPath="contract.signature.modal.success.done"
          onClick={handleCloseModal}
        />
      </div>
    );
  }

  return (
    <form
      className="mt-4 flex flex-col gap-4"
      noValidate
      onSubmit={handleSubmit}
    >
      <p className="text-text-secondary text-xs md:text-sm">
        {t('contract.signature.modal.description')}
      </p>

      <Input
        placeholder={t('contract.signature.modal.fields.signerName')}
        error={errors.signerName?.message}
        disabled={isSubmitting}
        {...register('signerName')}
      />

      <Input
        type="email"
        placeholder={t('contract.signature.modal.fields.signerEmail')}
        error={errors.signerEmail?.message}
        disabled={isSubmitting}
        autoComplete="email"
        {...register('signerEmail')}
      />

      <DocumentInput
        name="signerDocument"
        value={signerDocument}
        onChange={handleSignerDocumentChange}
        placeholder={t('contract.signature.modal.fields.signerDocument')}
        error={errors.signerDocument?.message}
        disabled={isSubmitting}
      />

      <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
        <Button
          color="ghost"
          className="sm:w-auto"
          labelPath="contract.signature.modal.cancel"
          onClick={handleCloseModal}
          disabled={isSubmitting}
        />
        <Button
          type="submit"
          color="primary"
          className="sm:w-auto"
          labelPath="contract.signature.modal.submit"
          isLoading={isSubmitting}
          disabled={isSubmitting}
        />
      </div>
    </form>
  );
}
